/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PerfPiracyPerformancePiracyProtocolsGetComplianceRateRequest,
  PerfPiracyPerformancePiracyProtocolsGetComplianceRateResponse,
  PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsRequest,
  PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsResponse,
  PerfPiracyPerformancePiracyProtocolsGetOffenderDataRequest,
  PerfPiracyPerformancePiracyProtocolsGetOffenderDataResponse,
  PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSearchEngineRequest,
  PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSearchEngineResponse,
  PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSocialMediaRequest,
  PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSocialMediaResponse,
  PerfPiracyPerformancePiracyProtocolsGetTopInfringingDomainsRequest,
  PerfPiracyPerformancePiracyProtocolsGetTopInfringingDomainsResponse,
  PerfPiracyPerformancePiracyProtocolsGetTopInfringingProfilesRequest,
  PerfPiracyPerformancePiracyProtocolsGetTopInfringingProfilesResponse,
  PerfPiracyPerformancePiracyProtocolsReportGetListRequest,
  PerfPiracyPerformancePiracyProtocolsReportGetListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PerformancePiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyListingsTimeSearchCreate
   * @request POST:/performance/piracy/listings-time-search
   */
  piracyListingsTimeSearchCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSearchEngineRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSearchEngineResponse, any>({
      path: `/performance/piracy/listings-time-search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyListingsTimeSocialCreate
   * @request POST:/performance/piracy/listings-time-social
   */
  piracyListingsTimeSocialCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSocialMediaRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetRemovedListingsOverTimeSocialMediaResponse, any>({
      path: `/performance/piracy/listings-time-social`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyOffenderDataCreate
   * @request POST:/performance/piracy/offender-data
   */
  piracyOffenderDataCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetOffenderDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetOffenderDataResponse, any>({
      path: `/performance/piracy/offender-data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyComplianceRateCreate
   * @request POST:/performance/piracy/compliance-rate
   */
  piracyComplianceRateCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetComplianceRateRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetComplianceRateResponse, any>({
      path: `/performance/piracy/compliance-rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyComplianceRateTopCreate
   * @request POST:/performance/piracy/compliance-rate-top
   */
  piracyComplianceRateTopCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetComplianceRateTopChannelsResponse, any>({
      path: `/performance/piracy/compliance-rate-top`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyTopInfringingDomainsCreate
   * @request POST:/performance/piracy/top-infringing-domains
   */
  piracyTopInfringingDomainsCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetTopInfringingDomainsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetTopInfringingDomainsResponse, any>({
      path: `/performance/piracy/top-infringing-domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyTopInfringingProfilesCreate
   * @request POST:/performance/piracy/top-infringing-profiles
   */
  piracyTopInfringingProfilesCreate = (
    data: PerfPiracyPerformancePiracyProtocolsGetTopInfringingProfilesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsGetTopInfringingProfilesResponse, any>({
      path: `/performance/piracy/top-infringing-profiles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformancePiracy
   * @name PiracyReportListCreate
   * @request POST:/performance/piracy/report/list
   */
  piracyReportListCreate = (
    data: PerfPiracyPerformancePiracyProtocolsReportGetListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyPerformancePiracyProtocolsReportGetListResponse, any>({
      path: `/performance/piracy/report/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
